
export default {
  isochrones: {
    isochrones: 'Isócronos',
    isochronesReady: 'Isócronos prontos',
    calculatingIsochrones: 'Calculando isócronos ...',
    itWasNotPossibleToCalculateIsochronesWithTheDefinedOptions: 'Não foi possível calcular o(s) isócrono(s) com as opções definidas. Tente definir isócrono(s) menores.',
    couldResolveTheSelectedPlaceAsASuitableCenter: 'Não foi possível resolver o ponto selecionado como um centro adequado.',
    apiError: {
      2003: 'A área de um polígono a ser evitada não deve exceder 20.0000 quilômetros quadrados.',
      3001: 'Um ou mais parâmetros têm um valor ou formato incorreto.',
      3004: 'A combinação de perfil, intervalo e tempo ou distância selecionada excede o máximo suportado. Por favor, ajuste os valores.',
      3099: 'Não foi possível construir um mapa isocrônico para o(s) ponto(s) e perfil selecionado(s).'
    },
    genericErrorMsg: 'Não foi possível calcular os isócronos.'
  }
}
